<template>
  <div
    :class="rootClasses"
    :data-cy="dataCy"
  >
    <DSBaseInputAffixContent
      :affix="props.affix"
      :type="props.type"
      :base-data-cy="dataCy"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { DS_BASE_INPUT_CLASSES } from "../constants/classes";
import DSBaseInputAffixContent from "@/src/design_system/form_elements/base_input/components/DSBaseInputAffixContent.vue";
import type { DSBaseInputAffixProps } from "@/src/design_system/form_elements/base_input/types/dsBaseInputAffix";
import { DS_BASE_INPUT_AFFIX_TYPE } from "@/src/design_system/form_elements/base_input/types";

const props = defineProps<DSBaseInputAffixProps>();

const rootClasses = computed(() => {
  return {
    [DS_BASE_INPUT_CLASSES.Prefix]: props.type === DS_BASE_INPUT_AFFIX_TYPE.Prefix,
    [DS_BASE_INPUT_CLASSES.Suffix]: props.type === DS_BASE_INPUT_AFFIX_TYPE.Suffix,
  };
});

const dataCy = computed(() =>
  props.type === DS_BASE_INPUT_AFFIX_TYPE.Prefix ? "ds-base-input__prefix" : "ds-base-input__suffix"
);
</script>
